import { Injectable } from '@angular/core';
import { Service } from './services';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { AlertasComponent } from './alertas/alertas.component';
import { LoadingScreenService } from './services/loading-screen/loading-screen.service';
import { Router } from '@angular/router';
import { Subject } from "rxjs";
import { Subscription } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  loadingPayment: Subscription;
  public requiredPasswordReset: boolean = false;
  private sessionCounter: number = 1;
  private minutes: number = 10;
  private timeout: number = 60000;//60000
  private checker: boolean = false;
  public pathChat: string = 'https://chat3.claropr.com/webapiserver/ECSApp/ChatWidget3/ChatPanel.aspx';
  public info = [];
  public usage2 = [];
  public urlPayment;
  public cancel = false;
  loadObserver = new Subject();
  initialize = new Subject();
  constructor(private router: Router, public dialog: MatDialog, public services: Service, private loadingScreenService: LoadingScreenService) { }
  doPayment(currentBan, mount, token) {
    if (mount >= 5 && mount <= 10000) {
      this.loadingScreenService.startLoading();
      this.services.doPayment(currentBan, mount, token).subscribe(data => {
        this.loadingScreenService.stopLoading();
        if (data.HasError == false) {
          window.open(data.response, '_blank');
        }
        else {
          this.notif(data.ErrorDesc);
        }
      });
    }
    else {
      if (mount < 5) {
        this.notif("El monto no puede ser menor a $5.00.");
      }
      else if (mount > 10000) {
        this.notif("El monto no puede ser mayor a $10000.00.");
      }
    }
  }
  isMobile() {
    return (
      (navigator.userAgent.match(/Android/i)) ||
      (navigator.userAgent.match(/webOS/i)) ||
      (navigator.userAgent.match(/iPhone/i)) ||
      (navigator.userAgent.match(/iPod/i)) ||
      (navigator.userAgent.match(/iPad/i)) ||
      (navigator.userAgent.match(/BlackBerry/i))
    );
  }
  openPDF(binary) {
    var iframe = "<iframe width='100%' height='100%' src='" + "data:application/pdf;base64," + binary + "'></iframe>"
    var x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();
  }

  openCSV(binary, billDate) {
    let csvContent = atob(binary);
    var blob = new Blob([csvContent], { type: "data:application/octet-stream;base64" });
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement("a");
    a.href = url;
    a.download = 'bill' + billDate + '.csv';
    document.body.appendChild(a);
    a.click();
  }

  newPayment(productId, typeMessage, currentBan, subscriber, amount, email, name, offerId, token, session = '') {
    if (amount.search('CR') > -1) {
      //Quitamos el CR para que no se envie al servicio
      amount = amount.replace("CR", "");
    }
    if (parseFloat(amount) >= 5 && parseFloat(amount) <= 99999.99) {
      this.loadingScreenService.startLoading();
      this.services.newPayment(productId, offerId).subscribe(data => {
        if (data.errorNum == 0) {
          if (data.paymentOptions.length > 0) {
            this.services.applyPayment("", 1, data.paymentOptions[0].paymentOptionId, amount, email, subscriber, currentBan, name, "dir1", "dir2", "san juan", "PR", "00956", "MICLAROWEB INVOICE PAYMENT", "", "", "", "").subscribe(data2 => {
              if (data2.errorNum == 0 && data2.hasError == false) {
                this.urlPayment = data2.redirectURL;
                this.loadingScreenService.stopLoading();
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                dialogConfig.autoFocus = true;
                dialogConfig.minWidth = "300px";
                dialogConfig.data = { message: "Será redirigido al portal de pago para completar el mismo por la cantidad de " + parseFloat(amount).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) + ".", colorSi: 'colorRed', colorNo: 'colorGray', btmConfirm: true, labelSi: 'Aceptar', labelNo: 'Cancelar' };

                const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
                dialogRef.afterClosed().subscribe(value => {
                  if (value == 'continue') {
                    //var windS= window.open(this.urlPayment, '_blank');
                    var windS = window.open(this.urlPayment, "Chat Mi Claro", "width=1000,height=800,scrollbars=NO");
                    if (windS == null || typeof (windS) == 'undefined') {

                      const dialogConfig = new MatDialogConfig();
                      dialogConfig.disableClose = true;
                      dialogConfig.autoFocus = true;
                      dialogConfig.data = { message: "Estimado cliente, la ventana ha sido bloqueada por el navegador, para poder realizar el pago habilite la opcion de la ventana emergente en el navegador." };
                      const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
                      dialogRef.afterClosed().subscribe(value1 => {
                        if (value1 == 'continue') {
                          this.loadingScreenService.startLoading(true, "Estimado Cliente, estamos esperando que habilite los permisos de la ventana emergente, si ya realizó el pago por favor espere que lo validemos.", true, session);
                          this.cancel = false;
                          this.verifyPaymentStatus(typeMessage, data2, 0, session);
                        }
                      });
                    }
                    else {
                      windS.focus();
                      this.loadingScreenService.startLoading(true, "Está siendo redirigido a la página del Banco Popular para realizar el pago.", true, session);
                      this.cancel = false;
                      this.verifyPaymentStatus(typeMessage, data2, 0, session);
                    }
                  }
                });
              }
              else {
                this.loadingScreenService.stopLoading();
                let username2 = sessionStorage.getItem("name");
                let accountName = username2.split(" ");
                this.notif("El servicio del banco no responde con la URL de pago.");
              }
            });
          }
          else {
            this.loadingScreenService.stopLoading();
            let username2 = sessionStorage.getItem("name");
            let accountName = username2.split(" ");
            this.notif("El servicio del banco no responde con la URL de pago.");
          }
        }
        else {
          this.loadingScreenService.stopLoading();
          let username2 = sessionStorage.getItem("name");
          let accountName = username2.split(" ");
          this.notif("El servicio del banco no responde con la URL de pago.");
        }
      });
    }
    else {
      if (parseFloat(this.convertCurrencyToNumber(amount)) < 5) {
        this.notif("El monto no puede ser menor a $5.00.");
      }
      else if (parseFloat(this.convertCurrencyToNumber(amount)) >= 100000) {
        this.notif("El monto no puede ser mayor a $99,999.99");
      }
    }
  }
  /*
  convertCurrencyToNumber(currency){
    try{
      var cur_re = /\D*(\d+|\d.*?\d)(?:\D+(\d{2}))?\D*$/;
      var parts = cur_re.exec(currency);
      var number = parseFloat(parts[1].replace(/\D/,'')+'.'+(parts[2]?parts[2]:'00'));
      console.log("retorno:"+number);
      return number.toFixed(2);
    }
    catch{
      console.log("sss");
    } 
  }
  */
  convertCurrencyToNumber(amount, decimals = 2) {
    amount += ''; // por si pasan un numero en vez de un string
    amount = parseFloat(amount.replace(/[^0-9\.]/g, '')); // elimino cualquier cosa que no sea numero o punto
    decimals = decimals || 0; // por si la variable no fue fue pasada
    // si no es un numero o es igual a cero retorno el mismo cero
    if (isNaN(amount) || amount === 0) {
      return 0;
    }
    // si es mayor o menor que cero retorno el valor formateado como numero
    amount = '' + amount.toFixed(decimals);
    var amount_parts = amount.split('.'), regexp = /(\d+)(\d{3})/;
    while (regexp.test(amount_parts[0])) {
      amount_parts[0] = amount_parts[0].replace(regexp, '$1' + ',' + '$2');
    }
    let reuslt = amount_parts.join('.');
    var re = /,/g;
    reuslt = reuslt.replace(re, '');
    //console.log(reuslt);
    return reuslt;
  }
  verifyPaymentStatus(typeMessage, data, cont, session = '') {
    //se evalua si se cancelo la carga en el loading
    this.loadingPayment = this.loadingScreenService.loadingStatus.subscribe((value: boolean) => {
      if (value == false) {
        this.cancel = true;
        this.loadingPayment.unsubscribe();
        this.loadingPayment.remove;
      }
    });

    let time = setTimeout(() => {
      if (this.cancel == true) {//si se cancela la carga se quita el tiempo y no carga mas el servicio
        this.cancel = false;
        clearTimeout(time);
      }
      else {
        this.loadingScreenService.startLoading(true, "Por favor espere, estamos verificando su pago.", true, session);
        this.services.verifyPaymentStatus(data.paymentToken).subscribe(result => {
          if (result.errorNum == 0) {
            if (result.processEndState == true) {
              if (result.hasError == false) {
                this.loadingScreenService.stopLoading();
                this.initialize.next();
              }
              else {
                this.loadingScreenService.stopLoading();
                this.notif(result.errorDisplay);
              }
            }
            else {
              if (cont < 2) {
                cont++;
                this.verifyPaymentStatus(typeMessage, data, cont);
              }
              else {
                if (typeMessage == 'payment') {
                  this.notif("Estimado cliente, hemos encontrado un problema al aplicar el pago en su cuenta. Si su pago fue autorizado por el banco, puede tomar entre 24 y 48 horas. Si tiene alguna duda con su pago favor de consultarle a Centro de Servicio al Cliente.");
                }
                else if (typeMessage == 'prepaid') {
                  this.notif("Estimado cliente, hemos encontrado un problema. Debe verificar su pago. Si su recarga fue autorizada por el banco, y no la ve reflejada en su cuenta de Claro Prepago, favor de consultarle a Centro de Servicio al Cliente.");
                }
                else {
                  this.notif("Estimado cliente, hemos encontrado un problema. Debe verificar su pago. Si su compra fue autorizada por el banco, y no la ve reflejada en su cuenta, favor de consultarle a Centro de Servicio al Cliente.");
                }
                this.loadingScreenService.stopLoading();
              }
            }
          }
          else {
            this.loadingScreenService.stopLoading();
            this.notif(result.errorDisplay);
          }
        });
      }
    }, 60000);
  }



  refreshDataTo(token, account, subscribe2 = "", loadingActive = true) {
    let subscriber;
    if (subscribe2 == "") {
      subscriber = this.getSuscriberByDefault(account);
    }
    else {
      subscriber = subscribe2;
    }
    if (loadingActive == true) {
      this.loadingScreenService.startLoading();
    }
    this.services.accountDetails(token, btoa(subscriber), btoa(account)).subscribe(data2 => {
      if (loadingActive == true) {
        this.loadingScreenService.stopLoading();
      }
      if (data2.HasError == false) {
        sessionStorage.setItem("getAccountDetails", btoa(JSON.stringify(data2)));
        this.loadObserver.next(0);
      }
      else {
        this.loadObserver.next(0);
        this.notif(data2.errorDisplay);
      }
    });
  }
  getSuscriberByDefault(accountId) {
    let subsriberByDefault = null;
    let accountList = JSON.parse(atob(sessionStorage.getItem("AccountList")));
    for (let i = 0; i < accountList.length; i++) {
      if (parseInt(accountList[i].account) === parseInt(accountId)) {
        subsriberByDefault = accountList[i].subsriberByDefault;
      }
    }
    return subsriberByDefault;
  }
  notif(msg) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { message: msg };
    const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
  }
  notifSignOff(msg) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { message: msg, session: true };
    const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
  }
  session() {
    sessionStorage.setItem("session", "true");
    this.sessionCounter = 1;

    setTimeout(() => {
      if (this.checker == false) {
        this.checker = true;
        this.activeSession(0, false);
      }
    }, this.timeout);
  }
  activeSession(sw, close) {
    if (close == false) {
      if (sw == 0) {
        if (this.sessionCounter == this.minutes) {
          if (sessionStorage.getItem("session") == "true") {
            this.notifSignOff('Su sesión se ha vencido.');
            this.signOff();
          }
        }
        else {
          if (sessionStorage.getItem("session") == "true") {
            this.sessionCounter++;
            setTimeout(() => { this.activeSession(0, false); }, this.timeout);
          }
        }
      }
      else {
        this.sessionCounter = 1;
        this.notifSignOff('Su sesión se ha vencido.');
        this.signOff();
      }
    }
    else {
      this.sessionCounter = 1;
      sessionStorage.setItem("session", "false");
    }
  }

  validateSession() {
    if (sessionStorage.getItem("session") == "false" || sessionStorage.getItem("session") == null) {
      this.router.navigate(['login']);
      return false;
    }
    else {
      this.session();
      return true;
    }
  }

  sessionReview() {
    if (sessionStorage.getItem("session") == "false" || sessionStorage.getItem("session") == null || sessionStorage.getItem("session") == undefined) {
      return false;
    }
    else {
      return true;
    }
  }
  public signOff() {
    this.checker = false;
    this.sessionCounter = 1;
    sessionStorage.setItem("session", "false");
    sessionStorage.setItem("objLogin", null);
    sessionStorage.setItem("menu", null);
    sessionStorage.setItem("suscriptorCreado", null);
    sessionStorage.setItem("session", null);
    sessionStorage.setItem("selectBan", null);
    sessionStorage.setItem("getAccountDetails", null);
    sessionStorage.setItem("getHistoricoFacturas", null);
    sessionStorage.setItem("GetPersonalData", null);
    sessionStorage.setItem("updatePersonalData", null);
    sessionStorage.setItem("userName", null);
    sessionStorage.setItem("userName2", null);
    sessionStorage.setItem("defaultSubscriber", null);
    sessionStorage.setItem("requiredAccountUpdate", null);
    sessionStorage.setItem("getAcoout", null);
    sessionStorage.setItem("token", null);
    sessionStorage.setItem("menu", null);
    sessionStorage.setItem("getPaymentHistory", null);
    sessionStorage.setItem("getquestions", null);
    sessionStorage.setItem("getChallengeQuestions2", null);
    sessionStorage.setItem("popPreguntasSeguridad", null);
    sessionStorage.setItem("banlist", null);
    sessionStorage.setItem("actualPdf", null);
    sessionStorage.setItem("email", null);
    sessionStorage.setItem("listData", null);
    sessionStorage.setItem("name", null);
    sessionStorage.setItem("companyName", null);
    sessionStorage.setItem("BillDateDonwload", null);
    sessionStorage.setItem("invoiceContentDonwload", null);

    sessionStorage.removeItem("invoiceContentDonwload");
    sessionStorage.removeItem("BillDateDonwload");
    sessionStorage.removeItem("name");
    sessionStorage.removeItem("listData");
    sessionStorage.removeItem("email");
    sessionStorage.removeItem("actualPdf");
    sessionStorage.removeItem("banlist");
    sessionStorage.removeItem("objLogin");
    sessionStorage.removeItem("menu");
    sessionStorage.removeItem("suscriptorCreado");
    sessionStorage.removeItem("session");
    sessionStorage.removeItem("selectBan");
    sessionStorage.removeItem("getAccountDetails");
    sessionStorage.removeItem("getHistoricoFacturas");
    sessionStorage.removeItem("GetPersonalData");
    sessionStorage.removeItem("updatePersonalData");
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("userName2");
    sessionStorage.removeItem("defaultSubscriber");
    sessionStorage.removeItem("requiredAccountUpdate");
    sessionStorage.removeItem("getAcoout");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("menu");
    sessionStorage.removeItem("getPaymentHistory");
    sessionStorage.removeItem("getquestions");
    sessionStorage.removeItem("getChallengeQuestions2");
    sessionStorage.removeItem("popPreguntasSeguridad");
    sessionStorage.removeItem("companyName");

  }
  checkProductType(productType) {
    let typeAccount;
    if (productType == 'C' || productType == 'G' || productType == 'K' || productType == 'P') {
      typeAccount = 'Movil';
    }
    else if (productType == 'I' || productType == 'V' || productType == 'D' || productType == 'H' || productType == 'N' || productType == 'O' || productType == 'T' || productType == 'E' || productType == 'S' || productType == 'J') {
      typeAccount = 'Fijo';
    }
    else {
      typeAccount = 'Fijo';
    }
    return typeAccount;
  }
  checkTypeAccount(productType) {
    let typeAccount: string = 'no-detect';
    if ((productType === 'H')) {
      typeAccount = 'Wholesale';
    }
    return typeAccount;
  }

  onlyNumberKey(e: KeyboardEvent) {
    if (((e.keyCode < 48 || e.keyCode > 57))) {
      e.preventDefault();
    }
  }
  validarEmail(email) {
    var expr = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!expr.test(email)) {
      return false;
    } else {
      return true;
    }
  }
  usage_info() {
    let counter1 = 0;
    let iDLocal: number = 0;
    let counter2 = 0;
    let percentage: number = 0;
    let counterPad = 0;
    let usage = '{';
    usage += '"subscribers":';
    usage += '[';
    for (var i = 0; i < this.info.length; i++) {
      counter2 = 0;
      counterPad = 0;
      if (counter1 > 0) { usage += ','; }
      usage += '{';
      usage += '"subscriber":';
      usage += '[';
      this.info[i].usageInfoField.dataOffersField.map(function (offers) {
        if (counter2 > 0) { usage += ','; }
        usage += '{';
        usage += '"offerGroup":"' + offers.offerGroupField + '",';
        usage += '"DPlanName":"' + offers.displayNameField + '",';
        usage += '"Quota":"' + offers.quotaField + '",';
        usage += '"DLocalTop":"' + offers.quotaTextField + '",';
        usage += '"iDLocal":"' + offers.usedField + '",';
        usage += '"iDLocalText":"' + offers.usedTextField + '",';
        if (parseFloat(offers.quotaField) > 0) {
          if (offers.usedField === null) {
            iDLocal = 0;
          }
          else {
            iDLocal = offers.usedField;
          }
          percentage = (iDLocal * 100) / parseFloat(offers.quotaField);
          percentage = parseInt(percentage.toString());
        }
        usage += '"percentage":' + percentage + ',';
        if (offers.offerGroupField.search('BASE') > -1) {
          usage += '"type":"PL-ACT"';
        }
        else if (offers.offerGroupField.search("NT_ROAM_GRANEL") > -1) {
          usage += '"type":"DR"';
        }
        else {
          if (counterPad === 0) {
            usage += '"type":"PQ-AD"';
          }
          else {
            usage += '"type":""';
          }
          counterPad++;
        }
        usage += '}';
        counter2++;
      });
      usage += '],"countDR":' + counter2 + ',"countPQAD":' + counterPad + ',"productType":"' + this.info[i].productTypeField + '"';
      usage += '}';
      counter1++;
    }
    usage += ']';
    usage += '}';
    this.usage2 = JSON.parse(usage).subscribers;
  }
  validateInputKey(key) {
    let exprValid = /([\-.,_\*@A-Z0-9áéíóú\s\\]+)/i;
    if (!exprValid.test(key.key)) {
      return false;
    }
    let exprInvalid = /(\-\-|[\!'\(\)\[\]\;\"]+)/g;
    key.target.value = key.target.value.replace(exprInvalid, "");

  }
  loadCanvas() {
    let objHtml;
    for (let i = 0; i < this.usage2.length; i++) {
      for (let j = 0; j < this.usage2[i].subscriber.length; j++) {
        objHtml = 'idCanvasPaq_' + i + '_' + j;
        this.pid2D(document.getElementById(objHtml), this.usage2[i].subscriber[j].percentage);
      }
    }
  }
  pid2D(elCanvas, proc) {
    let X = 110;
    let Y = 110;
    let radio = 80;
    let borde = 50;
    let giro = 4.74;
    let separacion = 0.030;
    let total = 6.28;
    let circulo = Math.PI * 2;
    if (proc === 100) {
      if (elCanvas && elCanvas.getContext) {
        let context = elCanvas.getContext('2d');
        let aPartida = 0;
        context.beginPath();
        context.strokeStyle = '#d9392d';
        context.lineWidth = borde;
        context.arc(X, Y, radio, giro, (total * 4), false);
        context.stroke();
        context.closePath();
      }
    }
    else if (proc === 0) {
      if (elCanvas && elCanvas.getContext) {
        let context = elCanvas.getContext('2d');
        let aPartida = 0;
        context.beginPath();
        context.strokeStyle = '#eaeaea';
        context.lineWidth = borde;
        context.arc(X, Y, radio, giro, (total * 4), false);
        context.stroke();
        context.closePath();
      }
    }
    else {
      let resultG1 = (total * proc) / 100;
      let resultG2 = resultG1 - circulo;

      if (elCanvas && elCanvas.getContext) {
        let context = elCanvas.getContext('2d');
        let aPartida = 0;
        context.beginPath();
        context.strokeStyle = '#d9392d';
        context.lineWidth = borde;
        context.arc(X, Y, radio, giro, ((resultG1 + giro) - separacion), false);
        context.stroke();
        context.closePath();

        context.beginPath();
        context.strokeStyle = '#eaeaea';
        context.lineWidth = borde;
        context.arc(X, Y, radio, (giro - separacion), ((resultG2 + giro)), true);
        context.stroke();
        context.closePath();
      }
    }
  }
  suspendedAccount(type, currentBan, defaultSubscriber, mount) {
    if (type == "S") {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.data = { message: 'Su cuenta ' + currentBan + ' esta suspendida. Para activar la misma, favor realice su pago.', btmConfirm: true, labelSi: 'Pagar', labelNo: 'Cancelar' };
      const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
      /* dialogRef.afterClosed().subscribe(value => {
         if (value == 'continue') {
           this.newPayment(1,currentBan,atob(defaultSubscriber),mount,atob(sessionStorage.getItem("email")),atob(sessionStorage.getItem("name")),"",sessionStorage.getItem("token"));
         }
       });*/
    }
  }

  openPDF2(data, date) {
    if (this.isMobile() != null) {
      var bin = atob(data);
      var obj = document.createElement('object');
      obj.style.width = '100%';
      obj.style.height = '842pt';
      obj.type = 'application/pdf';
      obj.data = 'data:application/pdf;base64,' + data;
      var link = document.createElement('a');
      link.download = 'bill' + date + '.pdf';
      link.href = 'data:application/octet-stream;base64,' + data;
      document.body.appendChild(link);
      link.click();
    }
    else {
      var byteCharacters = atob(data);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var file = new Blob([byteArray], { type: 'application/pdf;base64' });
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    }
  }
}